<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules", :class="formItemClass")
  el-input(:value="fieldModel", readonly :placeholder="placeholder")
</template>
<script>
import { staticMixins } from "@/CommonDP/VForm/utils";
export default {
  mixins: [staticMixins],
  data() {
    return {
      rules: []
    };
  },
  computed: {
    placeholder() {
      return this.options.placeholder;
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
